<div *dxTemplate="let tab of 'title'" class="tab-title">
  <span [ngClass]="tabs.indexOf(tab) === selectedIndex ? 'active-tab' : 'inactive-tab'">
    {{translateTitle ? (tab.title | translate) : tab.title}}
  </span>
</div>
